import { IconButton } from '@chakra-ui/react'
import React from 'react'

import { IconCircleAdd } from '~shared-components/icons/brand/IconCircleAdd'

interface AddPhoneButtonProps {
  disabled?: boolean
  onPhoneNumberAdded: VoidFunction
}

export const AddPhoneButton = ({
  disabled = false,
  onPhoneNumberAdded,
}: AddPhoneButtonProps) => (
  <IconButton
    _focus={{
      boxShadow: 'none',
      outline: '3px solid',
      outlineColor: 'blue.50',
      outlineOffset: '3px',
    }}
    aria-label="add phone number"
    data-analyticsid="add-phone-number-btn"
    icon={<IconCircleAdd boxSize="20px" color="green" />}
    isDisabled={disabled}
    justifyContent="center"
    minW="auto"
    mt={9}
    onClick={(e: React.MouseEvent) => {
      e.preventDefault()
      !disabled && onPhoneNumberAdded()
    }}
    p={0}
  />
)
